import React, {useEffect} from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useToken } from '../common/helper';
import "./Layout.scss";
import CustomHeader from './CustomHeader';
import CustomSidebar from './CustomSidebar';
import { fetchAllCouriers,selectCouriersState } from '../reudx-toolkit/slice/onboardingSlice';
import { fetchAllLocations, selectLocationState } from '../reudx-toolkit/slice/LocationSlice';
import { fetchAllProducts , selectProductState} from '../reudx-toolkit/slice/ProductSlice';
import { fetchAllProductTypes, selectProductTypeState } from '../reudx-toolkit/slice/ProductTypeSlice';
import { EditFilled } from '@ant-design/icons';
import { fetchMenu } from '../reudx-toolkit/slice/menuSlice';
import { fetchTeamsDDL } from '../reudx-toolkit/slice/teamsSlice';
import postscribe from 'postscribe';
function DashboardLayout({ children }) {
  const couriersState = useSelector(selectCouriersState)
  const productState = useSelector(selectProductState)
  const locationState = useSelector(selectLocationState)
  const productTypeState = useSelector(selectProductTypeState)
  const menu = useSelector((state) => state?.menu?.items);
  const teams = useSelector((state) => state?.teams?.list);
  const { token, decodedUserToken } = useToken();
  const decodedToken = decodedUserToken();
  const dispatch = useDispatch();
 const persistedState = localStorage.getItem('persist:root');
  //const targetElement = document.getElementById('target-element');
  const targetElement = document.getElementById('layout-connect');
  useEffect(() => {
    let obj={username:"",companyname:""};
    if (targetElement) {
      obj={
        username:decodedToken?.name || "",
        companyname:decodedToken?.company_name || ""
      }
      // const scriptContent = `
      //   <script type="text/javascript">
      //     (function(w, d, x, id){
      //       s=d.createElement('script');
      //       s.src='https://db08fjupg2abb.cloudfront.net/amazon-connect-chat-interface-client.js';
      //       s.async=1;
      //       s.id=id;
      //       d.getElementsByTagName('head')[0].appendChild(s);
      //       w[x] =  w[x] || function() { (w[x].ac = w[x].ac || []).push(arguments) };
      //     })(window, document, 'amazon_connect', 'c10b159f-c584-4f49-8192-66738e4be615');
      //     amazon_connect('styles', { iconType: 'CHAT', openChat: { color: '#ffffff', backgroundColor: '#123456' }, closeChat: { color: '#ffffff', backgroundColor: '#123456'} });
      //     amazon_connect('snippetId', 'QVFJREFIZ2ZYaENvQWJCb1ZtYmxRNlFMNVJYMlhab3BKY1p0RnRGQ2pJNGhxdnBvemdIdEZVL2xnY0dRRzZrNjRPN2NlcnVVQUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNTmFPaUlFdXRWMkkwZUdUTEFnRVFnQ3RZZEZmdFdqcjd0RjNMczd4ZFY0bitWN1l2d1I2WXQ5azNsd3BMZW52K0pZc3dKT3hTNzJSTStNUnM6Om9oVElDQTBndVl6YXJKQlJVZ2pSRVNXUTZzS0UwT0tHUHR6N2xVaEhjaHVYNHhiUkE5UGs4Y1FtMGJ5NG1iK0gya2s2bnl5dlBhQmVVQkl5Wnhsd0xKOENld0lLQmVjZnByS2lVT3dIS0dreUNJNjJBN2hQUG5iV1pveXdnbHVWTUJzTnV0S0xZQ3NKdThmdklMMjRwa2JQK3dGcm9raz0=');
      //     amazon_connect('supportedMessagingContentTypes', [ 'text/plain', 'text/markdown', 'application/vnd.amazonaws.connect.message.interactive', 'application/vnd.amazonaws.connect.message.interactive.response' ]);
      //   </script>
      // `;

       const scriptContent = `
        <script type="text/javascript">
  (function(w, d, x, id){
    s = d.createElement('script');
    s.src = 'https://zoomlogiconnect.my.connect.aws/connectwidget/static/amazon-connect-chat-interface-client.js';
    s.async = 1;
    s.id = id;
    d.getElementsByTagName('head')[0].appendChild(s);
    w[x] = w[x] || function() { (w[x].ac = w[x].ac || []).push(arguments) };
  })(window, document, 'amazon_connect', 'c10b159f-c584-4f49-8192-66738e4be615');

  amazon_connect('styles', {
    iconType: 'CHAT',
    openChat: { color: '#ffffff', backgroundColor: '#266ef1' },
    closeChat: { color: '#ffffff', backgroundColor: '#266ef1' }
  });

  amazon_connect('snippetId', 'QVFJREFIZ2ZYaENvQWJCb1ZtYmxRNlFMNVJYMlhab3BKY1p0RnRGQ2pJNGhxdnBvemdIdEZVL2xnY0dRRzZrNjRPN2NlcnVVQUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNTmFPaUlFdXRWMkkwZUdUTEFnRVFnQ3RZZEZmdFdqcjd0RjNMczd4ZFY0bitWN1l2d1I2WXQ5azNsd3BMZW52K0pZc3dKT3hTNzJSTStNUnM6Om9oVElDQTBndVl6YXJKQlJVZ2pSRVNXUTZzS0UwT0tHUHR6N2xVaEhjaHVYNHhiUkE5UGs4Y1FtMGJ5NG1iK0gya2s2bnl5dlBhQmVVQkl5Wnhsd0xKOENld0lLQmVjZnByS2lVT3dIS0dreUNJNjJBN2hQUG5iV1pveXdnbHVWTUJzTnV0S0xZQ3NKdThmdklMMjRwa2JQK3dGcm9raz0=');
//Change this dynamically
  amazon_connect('customerMetadata', {
    name: '${obj?.username}',
    company: '${obj?.companyname}'
  });

  amazon_connect('supportedMessagingContentTypes', [
    'text/plain',
    'text/markdown',
    'application/vnd.amazonaws.connect.message.interactive',
    'application/vnd.amazonaws.connect.message.interactive.response'
  ]);
</script>
      `;

      postscribe(targetElement, scriptContent);
    } else {
      console.error('Target element not found');
    }
  }, [targetElement]);
  
 

  useEffect(() => {
    if(token){
      if(couriersState?.courierList?.length==0){
        dispatch(fetchAllCouriers(token))
      }
      if(productState?.productList?.length==0){
        dispatch(fetchAllProducts(token))
      }
      if(locationState?.locationList?.length==0){
        dispatch(fetchAllLocations({token:token,toggle:false}))
      }
      if(productTypeState?.productTypeList?.length==0){
        dispatch(fetchAllProductTypes(token))
      }
      if(menu?.length==0){
       dispatch(fetchMenu(token));
      }
      if(teams?.length==0){
        dispatch(fetchTeamsDDL(token));
       }
    }
    else if (!persistedState && !token) {
      localStorage.clear();
    }
  },[]);

  return (
    <>
      <div  id="layout-connect" className="dashboard-container">
        <div className="sidebar">
          <CustomSidebar />
        </div>

        <div className="content">
          <div className="header">
            <CustomHeader />
          </div>

          <div className="main">
            {children}
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardLayout;
